import { createContext, useContext } from "react";

export const LoadContext = createContext(true);
export const useLoaded = () => useContext(LoadContext);
